import { render, staticRenderFns } from "./MobileSlotMain.vue?vue&type=template&id=211dfb86&scoped=true"
import script from "./MobileSlotMain.vue?vue&type=script&lang=js"
export * from "./MobileSlotMain.vue?vue&type=script&lang=js"
import style0 from "./MobileSlotMain.vue?vue&type=style&index=0&id=211dfb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211dfb86",
  null
  
)

export default component.exports